{
  "status": {
    "queued": "Queued",
    "processing": "Running",
    "completed": "Done",
    "failed": "Error",
    "cancelled": "Cancelled"
  },
  "statusDetail": {
    "preparing": "Preparing request",
    "sending": "Sending to API",
    "awaiting": "Generating",
    "downloading": "Downloading file",
    "saving": "Saving",
    "encoding": "Encoding",
    "handling": "Processing",
    "copying": "Copying",
    "improving_storyboard": "Improving frame prompt",
    "improving_video": "Improving video prompt",
    "registering": "Registering",
    "registering_asset": "Registering asset",
    "waiting_asset_active": "Waiting for asset activation",
    "designing": "Designing voice",
    "cloning": "Cloning voice",
    "importing": "Importing voice",
    "waiting_for_provider": "Waiting for provider",
    "provider_queued": "Queued at provider",
    "provider_running": "Generating",
    "fileProgress": "File {{current}} of {{total}}",
    "bulkProgress": "{{current}} of {{total}}"
  },
  "kind": {
    "season_structure": "Season",
    "episodes": "Episodes",
    "scenes": "Scenes",
    "shots": "Shots",
    "characters": "Characters",
    "locations": "Locations",
    "props": "Props",
    "storyboard": "Storyboard",
    "shooting_board": "Shooting board",
    "video": "Video",
    "video_with_reference_prep": "Video (references)",
    "video_with_animatic_reference_prep": "Video (animatic)",
    "assembly_export": "Assembly",
    "wizard_bootstrap": "Project wizard",
    "project_cover": "Project cover",
    "character_reference": "Character reference",
    "character_sheet": "Character sheet",
    "character_scale_pose": "A-pose",
    "scale_sheet_compose": "Scale sheet",
    "prop_front_view": "Prop front view",
    "prop_scale_sheet_compose": "Prop scale sheet",
    "mixed_scale_sheet_compose": "Mixed scale sheet",
    "character_emotion_sheet": "Emotion sheet",
    "character_portrait": "Character portrait",
    "character_expression_sheet": "Character emotion demo",
    "character_gait_reference": "Character gait demo",
    "character_action_beat": "Character action demo",
    "character_voice_demo": "Character voice demo",
    "seedance_avatar_registration": "Seedance asset registration",
    "seedance_asset_registration": "Seedance asset registration",
    "location_reference": "Location reference",
    "prop_reference": "Prop reference sheet",
    "medium_reference": "Medium preview",
    "camera_preset_demo": "Camera demo",
    "storyboard_correction": "Frame correction",
    "sketch_edit": "Sketch correction",
    "byteplus_seedance_video_correction": "Video correction (Seedance)",
    "topaz_post_production": "Video post-production",
    "flow_video_upscale": "Video upscale",
    "flow_video_depth": "Depth map",
    "shot_timeline_render": "Timeline render",
    "shot_timeline_lipsync": "Clip lipsync",
    "shot_timeline_tts": "Voice-over (TTS)",
    "shot_timeline_sts": "Voice change",
    "animatic_metadata": "Animatic",
    "animatic_web_preview": "Animatic web preview",
    "animatic_segment_poster": "Segment poster",
    "shot_frame_capture": "Shot screenshot",
    "animatic_segment_reference_clip": "Animatic reference video",
    "animatic_segment_export": "Animatic segment",
    "animatic_segment_transcription": "Segment transcription",
    "animatic_segment_shooting_board_strip": "Shooting board from animatic",
    "animatic_markers_split": "Animatic split by markers",
    "animatic_bulk_segments": "Bulk segment processing",
    "project_duplicate": "Project duplication",
    "project_export": "Project export",
    "bulk_improve_prompt": "Prompt improvement",
    "agent_create_shots_batch": "Create shots (agent)",
    "link_cast_llm": "Character placement on frames",
    "link_locations_llm": "Location placement on frames",
    "canvas_generate": "Canvas generation",
    "flow_bulk_regenerate": "Regenerate nodes",
    "voice_design_previews": "Voice design",
    "voice_remix_previews": "Voice remix",
    "voice_ivc_create": "Voice cloning",
    "voice_import": "Voice import",
    "file_to_skill": "Skill upload",
    "billing_operations_export": "Operations export",
    "billing_usage_export": "Usage log export",
    "promo_codes_export": "Promo codes export",
    "promo_redemptions_export": "Promo redemptions export",
    "promo_qr_export": "Promo QR codes",
    "promo_cards_export": "Promo business cards",
    "agent_chat": "Assistant chat",
    "agent_voice_prompt": "Voice input",
    "voice_dialogue_reference": "Dialogue reference",
    "voice_tts_preview": "Voice-over preview"
  },
  "toast": {
    "completed": "Done: {{kind}}",
    "completedWithErrors": "{{kind}}: {{done}} of {{total}} done, {{failed}} failed",
    "bulkAllFailed": "{{kind}}: no segments processed ({{failed}} failed)",
    "failed": "Error: {{kind}}",
    "failedWithMessage": "{{kind}} — {{message}}",
    "exportReady": "File is ready: {{label}} — click “Download”"
  },
  "historyLoadFailed": "Could not load history.",
  "requestLogsLoadFailed": "Could not load logs.",
  "noJobs": "No jobs.",
  "active": "Active",
  "history": "History",
  "loadMore": "Load more",
  "downloadExport": "Download export",
  "stopGeneration": "Stop generation",
  "stopGenerationConfirm": "Stop this generation?",
  "stopExport": "Cancel export",
  "stopExportConfirm": "Cancel this export?",
  "showRequestPayload": "Show request payload",
  "queueTitle": "Generation queue",
  "hideActions": "Hide actions",
  "startParallelGeneration": "Start another generation in parallel",
  "sketchSubjectPrefix": "Correction",
  "phase": {
    "units": {
      "sec": "{{count}} s",
      "min": "{{count}} min",
      "hour": "{{count}} h",
      "hourMin": "{{hours}} h {{minutes}} min"
    },
    "polls_one": "{{count}} readiness check",
    "polls_other": "{{count}} readiness checks",
    "queued": "Queued for {{elapsed}}",
    "claimed": "Picked up by a worker {{ago}} ago",
    "resumeWait": "{{status}} at the provider, {{polls}} · next check is waiting for a free worker for {{elapsed}}",
    "preparing_refs": "Preparing references for {{elapsed}}",
    "submitting": "Request to {{provider}} running for {{ago}}, waiting for the response",
    "submittingTimeout": "Request to {{provider}} running for {{ago}}, waiting for the response — times out in {{left}}",
    "in_flight": "Accepted by {{provider}} {{ago}} ago",
    "provider": "Provider status {{status}}, {{polls}}, last {{ago}} ago",
    "providerNoPolls": "Provider status {{status}} for {{elapsed}}",
    "parked": "Provider status {{status}}, {{polls}}, next check in {{left}}",
    "parkedDue": "Provider status {{status}}, {{polls}}, check was due {{ago}} ago",
    "downloading": "Getting the result for {{elapsed}}",
    "attaching": "Saving the result for {{elapsed}}",
    "stalled": "No heartbeat for {{ago}}",
    "stalledPreparingRefs": "Preparing references for {{elapsed}} — looks stuck",
    "stalledParkOverdue": "Provider check is {{ago}} overdue",
    "stalledFrom": "last phase: {{phase}}",
    "unknownStatus": "working",
    "noLogsYet": "No provider requests yet.",
    "phaseName": {
      "queued": "queue",
      "claimed": "picked up",
      "preparing_refs": "preparing references",
      "submitting": "request to provider",
      "in_flight": "task accepted",
      "provider_queued": "provider queue",
      "provider_running": "generating at provider",
      "parked": "waiting for check",
      "downloading": "getting the result",
      "attaching": "saving",
      "done": "done",
      "failed": "failed",
      "cancelled": "cancelled",
      "stalled": "looks stuck"
    }
  },
  "steps": {
    "queue": "Queue",
    "refs": "References",
    "submit": "Request",
    "provider": "At provider",
    "download": "Result",
    "save": "Saving"
  },
  "now": "Now · {{count}}",
  "recent": "Recent",
  "allProjectGenerations": "All project generations →",
  "detail": {
    "close": "Close",
    "stalledTitle": "Looks stuck",
    "stalledNoHeartbeat": "The worker shows no sign of life. Last phase: {{phase}}.",
    "stalledPreparingRefs": "Preparing references takes longer than usual — nothing reached the provider and nothing was charged.",
    "stalledParkOverdue": "The scheduled provider check is late. The task at the provider may still be running.",
    "worker": "Worker {{host}} · pid {{pid}}",
    "copyTaskId": "Copy task ID",
    "copied": "Copied",
    "timeline": "Progress",
    "timelineSynthetic": "Detailed progress is recorded since Nov 3 — only known moments are shown.",
    "timelineEmpty": "No progress yet.",
    "timelineNow": "now",
    "pollsNote_one": "{{count}} readiness check",
    "pollsNote_other": "{{count}} readiness checks",
    "attemptsNote_one": "{{count}} attempt",
    "attemptsNote_other": "{{count}} attempts",
    "resumesNote_one": "worker released {{count}} time",
    "resumesNote_other": "worker released {{count}} times",
    "refsNote": "references: {{count}}",
    "requests": "Provider requests · {{count}}",
    "requestsHidden": "The request log is available to project support.",
    "noRequests": "No provider requests yet.",
    "tabRequest": "Request",
    "tabResponse": "Response",
    "tabPolls": "Polls · {{count}}",
    "pendingRequest": "Not sent yet — the log row opens when the generation starts.",
    "attempt": "Attempt {{n}}",
    "prompt": "Prompt",
    "assets": "Assets",
    "settings": "Settings",
    "rawBody": "Raw body",
    "noBody": "Request body not saved",
    "noResponse": "No response",
    "noPolls": "No polls",
    "pollLast": "last {{time}}",
    "delivery": {
      "tos": "via TOS",
      "direct": "our link",
      "asset": "BytePlus asset",
      "inline": "inline",
      "external": "external link"
    },
    "loadFailed": "Could not load details"
  }
}
